<template>
  <header>
    <div class="row" v-if="merchant().SupportEmail !== undefined">
      <div v-if="getText('HeaderText').length>0" class="col-12 col-md-6 order-last order-md-first">
        <h2 class="title primary-color">{{getText('HeaderText')}}</h2>
        <div class='id-link' v-if='merchant().ShowHeaderInvoiceIdLink' v-html='invoice_id_string'></div>
      </div>
      <div class="col-12 col-md-6 order-first order-md-last logo-col">
        <img class="logo" :src="merchant().Logo" />
      </div>
    </div>
    <div class="row" v-if="merchant().SupportEmail == undefined">
      <div class="col-sm-12">
        <h2 class="title primary-color">{{getText('HeaderText')}}</h2>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

header {
  margin-bottom: 15px;
  padding-bottom: 10px;

  h2.title {
    font-size: 48px;
    line-height: 58px;
    text-align: center;

    @include media-breakpoint-up(md) {
      text-align: left;
    }
  }

  h6.sub-title {
    font-size: 18px;
  }

  .logo-col {
    margin-bottom: 10px;
    text-align: center;

    @include media-breakpoint-up(md) {
      text-align: right;
      margin-bottom: 0;
    }
  }

  .logo {
    height: 55px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
  name: "Header",
  components: {},
  computed: {
    invoice_id_string(){
			if(!this.merchant().ShowHeaderInvoiceIdLink) return '';
			var text = this.merchant().HeaderInvoiceIdLink.Text;
			var link = "<a href='"+this.merchant().HeaderInvoiceIdLink.TermsLink+"' target='_blank'>"+this.merchant().HeaderInvoiceIdLink.LinkText+"</a>";
			link = link.replace("{$id}", this.invoice().id);
			return text.replace("{$link}", link);
		}
  },
  methods: {
		getText(key){
			return LanguageService.getText(key);
		},
    ...mapGetters(["merchant", "invoice"])
  }
};
</script>
